// extracted by mini-css-extract-plugin
export var cardSizing = "bwcard-module--cardSizing--1w4xr";
export var bwCard = "bwcard-module--bwCard--YIPP7";
export var noBorder = "bwcard-module--noBorder--26jwz";